export default __webpack_public_path__ + "static/media/banner1.9c516979.jpg";